var m = require('mithril');

var component = {};

component.oninit = function oninit (vnode) {
  vnode.state.showPassword = false;
};

component.view = function view (vnode) {
  var showPassword = !!vnode.state.showPassword;
  var toggleLabel = showPassword ? 'Hide password' : 'Show password';

  return m('div.login-password-input-row.mb2', [
    m('input.pa2.login-input', {
      name: 'password',
      type: showPassword ? 'text' : 'password',
      autocomplete: 'current-password',
      placeholder: 'PASSWORD',
      oninput: function (ev) {
        vnode.attrs.password(ev.target.value);
      },
      value: vnode.attrs.password()
    }),
    m('button.login-password-toggle', {
      type: 'button',
      title: toggleLabel,
      'aria-label': toggleLabel,
      'aria-pressed': showPassword ? 'true' : 'false',
      onclick: function () {
        vnode.state.showPassword = !showPassword;
      },
      onmousedown: function (ev) {
        ev.preventDefault();
      }
    }, [
      m('i.blue.' + (showPassword ? 'ion-eye-disabled' : 'ion-eye'))
    ])
  ]);
};

module.exports = component;
